(function () {
  const PIXEL_SELECTOR = 'img[src*="data.adxcel-ec2.com/pixel"]';
  const SR_ONLY_CLASS = 'sr-only';

  function fixPixel(img) {
    if (!img.hasAttribute('alt')) {
      img.setAttribute('alt', '');
    }
    img.setAttribute('aria-hidden', 'true');
  }

  function fixHereLink(link) {
    const text = link.textContent.trim().toLowerCase();

    if (text === 'here' && link.hasAttribute('title')) {
      const title = link.getAttribute('title');
      if (!title) return;

      // Add aria-label if missing
      if (!link.hasAttribute('aria-label')) {
        link.setAttribute('aria-label', title);
      }

      // Add sr-only descriptive text (once)
      if (!link.querySelector('.' + SR_ONLY_CLASS)) {
        const span = document.createElement('span');
        span.className = SR_ONLY_CLASS;
        span.textContent = ' – ' + title;
        link.appendChild(span);
      }
    }
  }

  function scan(root = document) {
    root.querySelectorAll(PIXEL_SELECTOR).forEach(fixPixel);
    root.querySelectorAll('a').forEach(fixHereLink);
  }

  function init() {
    scan();

    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType !== 1) return;
          
          if (node.matches?.(PIXEL_SELECTOR)) fixPixel(node);
          if (node.matches?.('a')) fixHereLink(node);
        });
      });
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();